import { render } from "./Sketch.vue?vue&type=template&id=25e3c7fa&scoped=true&ts=true"
import script from "./Sketch.vue?vue&type=script&lang=ts"
export * from "./Sketch.vue?vue&type=script&lang=ts"

import "./Sketch.vue?vue&type=style&index=0&id=25e3c7fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e3c7fa"]])

export default __exports__